// Native & external imports
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AppRouterService } from "src/routing/routes-service";
import { LayoutService } from "src/services/layout.service";

@Component({
  standalone: false,
  selector: "cmp-camper-logout",
  templateUrl: "./logout.component.html",
})
export class LogoutComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private routerService = inject(AppRouterService);
  private layoutService = inject(LayoutService);

  ngOnInit() {
    this.layoutService.logOut(false);
  }

  ngOnDestroy() {}

  public redirectToLogin(): void {
    this.router.navigate([this.routerService.componentsUrl.login]);
  }
}
